import ActionTypes from '@constants/action_types.js'
import UserAPI from '@api/user_web_api.js'
import { handleLoadMeSuccess, handleLoadMeError } from './user_server_actions.js'

export function loadCurrentUser() {
  return (dispatch, getState) => {
    UserAPI.me().then(
      res => {
        dispatch(handleLoadMeSuccess(res))
      },
      err => {
        dispatch(handleLoadMeError(err))
      }
    )
  }
}

export function receiveUsers(users) {
  return {
    type: ActionTypes.RECEIVE_USERS,
    payload: users,
  }
}

export function receiveCurrentUser(user) {
  return {
    type: ActionTypes.RECEIVE_CURRENT_USER,
    payload: user,
  }
}

export function removeUsers(userIds = []) {
  return {
    type: ActionTypes.REMOVE_USERS,
    payload: userIds,
  }
}
